import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark, oceanicNext } from "@code-surfer/themes";
import { Msg } from "../../../../../../src/Msg.js";
import { MsgOnlyName } from "../../../../../../src/MsgOnlyName.js";
import React from 'react';
export default {
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  github: github,
  vsDark: vsDark,
  oceanicNext: oceanicNext,
  Msg: Msg,
  MsgOnlyName: MsgOnlyName,
  React: React
};